import React, { useState } from "react";
import { api } from "@/lib/api";
import { toast } from "sonner";
import { Input, Btn } from "@/components/erp/ui";

// Tambah merek baru + berat spool/botol kosong (tersimpan di pengaturan Spool & Stiker)
export const BrandAdd = ({ onAdded }) => {
  const [open, setOpen] = useState(false); const [f, setF] = useState({ brand: "", tare_g: 200 }); const [busy, setBusy] = useState(false);
  const save = async () => {
    setBusy(true);
    try { const { data } = await api.post("/stock-meta/brands", { brand: f.brand, tare_g: +f.tare_g }); toast.success(`Merek ${data.brand} ditambahkan (kosong ${data.tare_g} g)`); setOpen(false); setF({ brand: "", tare_g: 200 }); onAdded(data.brand); }
    catch (e) { toast.error(typeof e?.response?.data?.detail === "string" ? e.response.data.detail : "Gagal"); }
    setBusy(false);
  };
  if (!open) return <button type="button" data-testid="sf-brand-add" className="text-xs text-sky-700 underline whitespace-nowrap" onClick={() => setOpen(true)}>+ Merek</button>;
  return (
    <div className="col-span-2 rounded-lg border border-sky-200 bg-sky-50/50 p-2 flex flex-wrap items-end gap-2" data-testid="sf-brand-add-box">
      <label className="text-[11px] text-slate-500 flex-1 min-w-[140px]">Merek baru<Input data-testid="sf-brand-new" value={f.brand} onChange={(e) => setF({ ...f, brand: e.target.value })} placeholder="mis. Polymaker" /></label>
      <label className="text-[11px] text-slate-500 w-36">Berat spool/botol kosong (g)<Input type="number" data-testid="sf-brand-new-tare" value={f.tare_g} onChange={(e) => setF({ ...f, tare_g: e.target.value })} /></label>
      <Btn data-testid="sf-brand-new-save" disabled={busy || !f.brand.trim() || !(+f.tare_g > 0)} onClick={save}>Simpan</Btn>
      <Btn variant="ghost" data-testid="sf-brand-new-cancel" onClick={() => setOpen(false)}>Batal</Btn>
    </div>
  );
};
